module.exports = __webpack_public_path__ + "static/media/facebook.a28769c8.PNG";